import { useMemo } from 'react';
import {
  useBaseOwnerFilters,
  useGlobalComponent,
  useModelContext
} from '@rhino-project/core/hooks';
import {
  getModelAndAttributeFromPath,
  getModelFromRef
} from '@rhino-project/core/utils';
import { RhinoResource } from '@rhino-project/core';
import { ModelFilterReferenceBase } from './ModelFilterReference';

interface ModelFilterOwnerReferenceProps {
  path: string;
  [key: string]: unknown;
}

// The base-owner scoping filter must be built against the referenced model
// (the model whose records populate the dropdown), not the index model from
// context — an index-model filter is in the wrong coordinate space for the
// referenced model's endpoint and the backend sieve silently drops it,
// leaving the options unscoped.
export const useReferenceBaseOwnerFilter = (path: string) => {
  const { model } = useModelContext();

  const refModel = useMemo(() => {
    const [, attribute] = getModelAndAttributeFromPath(
      model as RhinoResource,
      path
    );
    return getModelFromRef(attribute!);
  }, [model, path]);

  return useBaseOwnerFilters(refModel as RhinoResource);
};

export const ModelFilterOwnerReferenceBase = (
  props: ModelFilterOwnerReferenceProps
) => {
  const filter = useReferenceBaseOwnerFilter(props.path);

  return <ModelFilterReferenceBase filter={filter} {...props} />;
};

export const ModelFilterOwnerReference = (
  props: ModelFilterOwnerReferenceProps
) =>
  useGlobalComponent(
    'ModelFilterOwnerReference',
    ModelFilterOwnerReferenceBase,
    props
  );
